// src/store/reducers/ticketsReducer.js
import { GET_TICKETS_REQUEST, GET_TICKETS_SUCCESS, GET_TICKETS_FAIL, ADD_TICKET, UPDATE_TICKET, DELETE_TICKET } from "../actions/ticketsActions";

const initialState = { loading: false, list: [], error: null };

export default function ticketsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TICKETS_REQUEST:
      return { ...state, loading: true };
    case GET_TICKETS_SUCCESS:
      return { ...state, loading: false, list: action.payload || [] };
    case GET_TICKETS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case ADD_TICKET:
      return { ...state, list: [action.payload, ...state.list] };
    case UPDATE_TICKET:
      return { ...state, list: state.list.map((t) => (t._id === action.payload._id ? action.payload : t)) };
    case DELETE_TICKET:
      return { ...state, list: state.list.filter((t) => t._id !== action.payload._id) };
    default:
      return state;
  }
}
